import { Component, OnInit } from '@angular/core';
import { OsnovZaPlacenoOdsustvo } from './osnov-za-placeno-odsustvo';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-osnov-za-placeno-odsustvo',
  templateUrl: './osnov-za-placeno-odsustvo.component.html'
})
export class OsnovZaPlacenoOdsustvoComponent extends BaseModalContainer<OsnovZaPlacenoOdsustvo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsnovZaPlacenoOdsustvo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
